<template>
    <q-dialog v-model="show" seamless position="bottom">
        <q-card>
            <q-card-section>
                <noindex classes="row items-center no-wrap">
                    <div class="q-pr-sm">Сайт kc-shoes.ru использует файлы cookies. Продолжая использовать наш сайт, вы автоматически соглашаетесь с использованием данных технологий.</div>
                    <div class="q-space"></div>
                    <q-btn square outlined color="primary" label="Ок" @click.prevent="accept()"/>
                </noindex>
            </q-card-section>
        </q-card>
    </q-dialog>
</template>

<script>
export default {
    name: "ConfirmCookies",
    data() {
        return {
            show: false
        }
    },
    mounted() {
        let cookiesDate = this.cookiesDate();

        if (!cookiesDate || (+cookiesDate + 31536000000) < Date.now()) {
            this.cookiesDate(true);
            this.show = true;
        }
    },
    methods: {
        cookiesDate(set) {
            let date = localStorage.getItem('confirm_cookies_date');

            if (set) {
                date = Date.now();
                localStorage.setItem('confirm_cookies_date', date.toString());
            }
            return date;
        },
        accept() {
            this.show = false;
        }
    }
}
</script>
